// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3wweB","errors":"Errors_errors__T_7b4"};